import * as userTypes from "Store/user/constants";

export const setUserIsLogged = (value) => ({
  type: userTypes.SET_USER_IS_LOGGED,
  value
});

export const getCurrentUser = () => ({
  type: userTypes.HANDLE_FETCH_CURRENT_USER
});

export const getOnlyCurrentUser = () => ({
  type: userTypes.HANDLE_FETCH_ONLY_CURRENT_USER
});

export const setAuthorizedStatus = (status) => ({
  type: userTypes.SET_AUTHORIZED_STATUS,
  status
});

export const updateAvatar = (payload) => ({
  type: userTypes.HANDLE_UPDATE_AVATAR,
  payload
});

export const changePassword = (payload) => ({
  type: userTypes.HANDLE_CHANGE_PASSWORD,
  payload
});

export const requestResetPassword = (email) => ({
  type: userTypes.HANDLE_REQUEST_RESET_PASSWORD,
  email
});

export const setCurrentUser = (user) => ({
  type: userTypes.SET_CURRENT_USER,
  user
});

export const toggleShowWelcomeModal = (toggle) => ({
  type: userTypes.SHOW_WELCOME_MODAL,
  toggle
});

export const handleUpdateLastVersionSeen = (
  payload: LastVersionSeenRequest
): userTypes.IHandleUpdateLastVersionSeen => ({
  type: userTypes.HANDLE_UPDATE_LAST_VERSION_SEEN,
  payload
});

export const setUserAvatar = (avatar) => ({ type: userTypes.SET_USER_AVATAR, avatar });

export const handleImpersonate = (payload: ImpersonatePayload): userTypes.IHandleImpersonate => ({
  type: userTypes.HANDLE_IMPERSONATE,
  payload
});

export const handleLogout = (): userTypes.IHandleLogout => ({ type: userTypes.HANDLE_LOGOUT });
export const handleLogin = (payload: LoginPayload): userTypes.IHandleLogin => ({
  type: userTypes.HANDLE_LOGIN,
  payload
});

export const handleUpdateUserProfile = (
  user: User,
  avatar: FormData
): userTypes.IHandleUpdateUserProfile => ({
  type: userTypes.HANDLE_UPDATE_USER_PROFILE,
  payload: {
    avatar,
    user
  }
});
